import dataset from '@talend/dataset';
import { middlewares as cqrsMiddlewares } from '@talend/react-cmf-cqrs';

import { API } from './constants';

export default function createMiddleware(): any {
	// eslint-disable-next-line
	return cqrsMiddlewares.createWebsocketMiddleware(
		API['catalog-websocket'],
		[],
		[dataset.datasetWebsocketMiddleware],
	);
}
